<script setup>
defineProps({
    message: {
        type: String,
    },
});
</script>

<template>
    <div class="relative group/tooltip">
        <span class="sr-only">{{ message }}</span>
        <div class="absolute hidden h-6 bg-gray-800 text-white text-xs p-1 rounded whitespace-nowrap z-10 left-1/2 transform -translate-x-1/2 -translate-y-7 group-hover/tooltip:block">
            {{ message }}
        </div>
        <slot />
    </div>
</template>
